import {
  Device,
  GameController,
  GameGenre,
  GameStatus,
  PEGIRating,
  Tile,
} from "../model";
import { apiService } from "./ApiService";

export enum SessionDuration {
  LESS_10 = "< 10 mn",
  BETWEEN_10_30 = "10 - 30 mn",
  MORE_30 = "> 30 mn",
}
export interface SearchFormData {
  controllers?: GameController[];
  devices?: Device[];
  genres?: GameGenre[];
  languages?: string[];
  multiplayer?: boolean;
  solo?: boolean;
  name?: string;
  sessionDurations?: SessionDuration[];
  statuses?: GameStatus[];
  age?: PEGIRating[];
  publisher?: string;
}

/**
 * 
 * 
 * 
  public search(
    query: SearchFormData,
    offset = 0,
    tilesLimit?: number,
  ): Observable<List> {
    const path = `search/games`;
    const params: RequestParam = { offset: `${offset}` };
    if (tilesLimit !== undefined) {
      params.limitTiles = `${tilesLimit}`;
    }

    return this.doPrivateRequest(
      'post',
      path,
      { ...query, genres: query.genres && query.genres.map(e => e.id) },
      params,
    ).pipe(map(searchResults2List));
  }

 */

export interface SearchResults {
  isPaginated: boolean;
  tiles: Tile[];
  total: number;
}

const searchGames = (query: SearchFormData, offset = 0, limit = 10) => {
  return apiService.post<SearchResults>({
    path: "public/games",
    edito: true,
    body: {
      ...query,
      genres: query.genres && query.genres.map((e) => e.id),
    },
    params: {
      offset: `${offset}`,
      limit: `${limit}`,
    },
  });
};
export { searchGames };
